import { AxiosPromise } from 'axios';
import { EndPointService } from 'src/services/api-handlers/axios';

function getStudents(params: any): AxiosPromise {
    return EndPointService.get('/students', { params });
}
function getStudentsSmall(params: any): AxiosPromise {
    const res = EndPointService.get('/students-simply-list', { params });
    return res;
}

function getStudent(id: number | string): AxiosPromise {
    return EndPointService.get(`/students/${id}`);
}

function deleteStudent(id: number | string): AxiosPromise {
    return EndPointService.delete(`/students/${id}`);
}

function createStudent(payload: any): AxiosPromise {
    return EndPointService.post('/students', payload);
}

function deleteFileStudent(fileId: number | string): AxiosPromise {
    return EndPointService.delete(`/student_docs/${fileId}`);
}

function createFilesStudent(data: any): AxiosPromise {
    return EndPointService.post(`/student_docs`, data);
}
function createOrderDocStudent(data: any, id: string | number): AxiosPromise {
    return EndPointService.post(`/students/order-doc`, data, { params: { id } });
}

function createConsentDocStudent(data: any, id: string | number): AxiosPromise {
    return EndPointService.post(`/students/consent-doc`, data, { params: { id } });
}

function createParentConsentDocStudent(data: any, id: string | number): AxiosPromise {
    return EndPointService.post(`/students/parent-consent-doc`, data, { params: { id } });
}

function createIntakeStudent(data: any, id: string | number, intakeType: string | number): AxiosPromise {
    return EndPointService.post(`/student_intakes`, data, { params: { id, formId: intakeType } });
}

function getFilesStudent(id: string | number): AxiosPromise {
    return EndPointService.get(`/student_docs`, {
        params: {
            'student.id': id,
        },
    });
}

function getIntakesStudent(id: string | number): AxiosPromise {
    return EndPointService.get(`/student_intakes`, {
        params: {
            'student.id': id,
        },
    });
}

function updateStudent(id: number | string, payload: any): AxiosPromise {
    return EndPointService.put(`/students/${id}`, { ...payload });
}
function patchStudent(payload: any): AxiosPromise {
    return EndPointService.put(`/students/status`, payload);
}

export default {
    getStudents,
    getStudentsSmall,
    getFilesStudent,
    getIntakesStudent,
    createFilesStudent,
    createConsentDocStudent,
    createParentConsentDocStudent,
    createOrderDocStudent,
    deleteFileStudent,
    getStudent,
    deleteStudent,
    createStudent,
    updateStudent,
    patchStudent,
    createIntakeStudent,
};
